import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Nav from "../navigation/Nav";
import Menu from "../navigation/Menu";
import "moment/locale/nl";
import { AiOutlineLeft } from "react-icons/ai";
import "../../scss/customers/create_customer.scss";
import "../../scss/customers/customer.scss";
import _ from "lodash";
import Swal from "sweetalert2";

// API functions
import { create_customer } from "../../functions/api.js";
import ObjectenSection from "./objecten/ObjectenSection";

const Field = ({ label, field, type = "text", autoComplete = "on", data, set }) => (
  <div>
    <label className="label-customer">{label}</label>
    <div className="input-color">
      <input type={type} value={data[field]} onChange={set(field)} autoComplete={autoComplete} />
    </div>
  </div>
);

function EditCustomer() {
  const navigate = useNavigate();
  const location = useLocation();

  const [userInput, setUserInput] = useState({
    id: "",
    active: "",
    telefoon: "",
    email: "",
    website: "",
    klantnaam: "",
    bedrijfsnaam: "",
    adres: "",
    huisnummer: "",
    postcode: "",
    plaats: "",
    locatieid: "",
  });

  const [objectenArr, setObjectenArr] = useState([]);

  useEffect(() => {
    if (location.state && location.state.customer) {
      const { customer } = location.state;
      setObjectenArr(customer.objecten || []);
      for (let key in customer) {
        if (_.isObject(customer[key])) {
          for (let sKey in customer[key]) {
            setUserInput((prev) => ({ ...prev, [sKey]: customer[key][sKey] }));
          }
        } else {
          setUserInput((prev) => ({ ...prev, [key]: customer[key] }));
        }
      }
    }
  }, [location]);

  const set = (field) => (e) =>
    setUserInput((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async () => {
    try {
      const customerData = {
        id: userInput.id,
        active: userInput.active,
        telefoon: userInput.telefoon,
        email: userInput.email || "",
        website: userInput.website,
        klantnaam: userInput.klantnaam,
        bedrijfsnaam: userInput.bedrijfsnaam,
        locatie: {
          locatieid: userInput.locatieid,
          locatienaam: "",
          adres: userInput.adres,
          huisnummer: userInput.huisnummer,
          postcode: userInput.postcode,
          plaats: userInput.plaats,
        },
        objecten: objectenArr,
      };
      await create_customer(customerData);
      navigate("/customers");
      Swal.fire("Succes!", "Klantgegevens zijn succesvol bijgewerkt.", "success");
    } catch (error) {
      console.error("Error submitting customer data:", error);
      Swal.fire("Fout!", "Er is een fout opgetreden bij het bijwerken van de klantgegevens.", "error");
    }
  };

  return (
    <div className="select-customer-container-main">
      <Nav page="Rapportages" />
      <div className="page-wrap-row">
        <Menu className="menu-container" />
        <div className="create-customer">
          <Link
            className="fixed bottom-0 left-0 ml-4 mb-4"
            to="/customers"
            style={{ textDecoration: "none", color: "#757575", width: "85px" }}
          >
            <p className="text-base flex flex-row">
              <AiOutlineLeft className="mt-1" />
              terug
            </p>
          </Link>

          <h1 className="customer-header mt-12 md:mt-10 lg:mt-8">Klant</h1>
          <hr className="hr2" />

          <div style={{ paddingBottom: 16 }}>
            {/* Naam + Bedrijfsnaam */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <Field label="Naam" field="klantnaam" data={userInput} set={set} />
              <Field label="Bedrijfsnaam" field="bedrijfsnaam" data={userInput} set={set} />
            </div>

            {/* Adres */}
            <div className="mb-6">
              <Field label="Adres (straat)" field="adres" data={userInput} set={set} />
            </div>

            {/* Postcode + Huisnummer + Plaats */}
            <div className="grid grid-cols-3 gap-4 mb-6">
              <Field label="Postcode" field="postcode" data={userInput} set={set} />
              <Field label="Huisnummer" field="huisnummer" data={userInput} set={set} />
              <Field label="Plaats" field="plaats" data={userInput} set={set} />
            </div>

            {/* Telefoon + Email */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <Field label="Telefoon" field="telefoon" data={userInput} set={set} />
              <Field label="Email" field="email" data={userInput} set={set} />
            </div>

            {/* Website */}
            <div className="mb-6">
              <Field label="Website" field="website" data={userInput} set={set} />
            </div>

            <ObjectenSection
              objecten={objectenArr}
              customerDefaults={{
                klantid: userInput.id,
                locatie: {
                  adres: userInput.adres,
                  huisnummer: userInput.huisnummer,
                  postcode: userInput.postcode,
                  plaats: userInput.plaats,
                },
              }}
              onChange={setObjectenArr}
            />

          </div>
          <div className="sticky-action-bar">
            <button className="submit-customer" onClick={handleSubmit}>
              Opslaan
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditCustomer;
